export default "__VITE_ASSET__B7t_kJnM__"